import styled from "styled-components";

const UseCases = ({ data = [], title = "What This Means for You" }) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <Section aria-labelledby="usecases-heading">
      <Container>
        <Header id="usecases-heading">{title}</Header>

        <Grid>
          {data.map((uc, i) => {
            const Icon = uc.icon; // react-icons component
            return (
              <Card key={uc.title ?? i}>
                <IconBadge aria-hidden="true">
                  {Icon ? <Icon size={18} /> : null}
                </IconBadge>

                <Content>
                  <Title>{uc.title}</Title>
                  {uc.description && <Desc>{uc.description}
                     {/* {uc.comingSoon && <ComingSoon>Coming Soon..</ComingSoon>} */}
                     </Desc>}
                </Content>
              </Card>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
};

export default UseCases;

/* ---------------- styles ---------------- */

const Section = styled.section`
  padding: 64px 20px;
  background: #f6f7fb; /* light surface like your shot */
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Header = styled.h2`
  text-align: center;
  font: 800 36px/1.2 Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  margin: 0 0 28px;
  letter-spacing: -0.6px;
  color: #0f172a;

  @media (max-width: 991px) {
    font-size: 32px;
    line-height: 1.3;
    margin: 1rem 0 4rem;
  }

  @media (max-width: 640px) {
    font-size: 30px;
    line-height: 1.2;
    margin: 0.1rem 0 3rem;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 22px;
`;

const Card = styled.article`
  flex: 0 0 calc(28.7% - 10px);
  background: #fff;
  border-radius: 24px;
  padding: 22px;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.06);
  border: 1px solid #eef0f4;
  display: grid;
  gap: 16px;
  align-items: start;
  @media (max-width: 1149px) {
    flex: 0 0 calc(38.7% - 10px);
  }
  @media (max-width: 514px) {
    flex: 0 0 calc(90% - 10px);
  }
`;

const IconBadge = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: radial-gradient(147% 147% at 14% 0%, #eee8ff 0%, #e6e2ff 60%, #efefff 100%);
  color: #6b37e3; /* primary purple for icon */
`;

const Content = styled.div`
  display: grid;
  gap: 8px;
`;

const Title = styled.h3`
  margin: 0;
  font: 700 20px/1.35 Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  color: #111827;
`;

const Desc = styled.p`
  margin: 0;
  color: #4b5563;
  font: 500 14px/1.7 Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
`;

const ComingSoon = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 4px 8px;
  background-color: #fffae6;
  font-style: italic;
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
`;
